import "preline";

// Need to import ClipboardJS from the window object so that helpers can use it
import ClipboardJS from "clipboard";
window.ClipboardJS = ClipboardJS;

// Not needed as we override the default Preline helper with custom fix
// import "preline/dist/helper-clipboard.js";

console.debug("Preline clipboard helpers loaded");
